module.exports = __webpack_public_path__ + "static/img/2.0ed2800.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/2.png
// module id = Jt8u
// module chunks = 0